import { NganhService } from "../services/nganh.service";

var state = {
	nganhs: [],
};

var getters = {};

var mutations = {
	getNganhs(state, data) {
		state.nganhs = [...data.sort((a, b) => a.tenNganh.localeCompare(b.tenNganh))];
	},
};

var actions = {
	getNganhs({ commit }, dotDangKyId) {
		return NganhService.getNganhs(dotDangKyId)
			.then((response) => {
				if (response.status == 200) commit("getNganhs", response.data);
				return response;
			})
			.catch((error) => error);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
